module.exports = __webpack_public_path__ + "img/9.565ad4a3.jpeg";